import httpService from './httpService';
import { Basin } from '../utils/types';

export const createBasin = async (basin: Basin) => {
	const { data } = await httpService.post(`/basins`, basin);
	return data;
};

export const search = async (params?: any) => {
	const { data } = await httpService.get(`/basins/search`, { params });
	return data;
};

export const getBasin = async (id: string) => {
	const { data } = await httpService.get(`/basins/${id}`);
	return data;
};

export const deleteBasin = async (id: any) => {
	const { data } = await httpService.delete(`/basins/${id}`);
	return data;
};

export const updateBasin = async (basin: any) => httpService.put(`/basins/${basin.id}`, basin);
